import { useEffect } from 'react';

export interface SeoConfig {
  title: string;
  description: string;
  keywords: string;
  path: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_NAME = '爆料专区导航';
const BASE_URL = 'https://hnbhcpa.cn';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useSeo(config: SeoConfig) {
  const deps = JSON.stringify(config);

  useEffect(() => {
    document.title = config.title;
    setMeta('name', 'description', config.description);
    setMeta('name', 'keywords', config.keywords);
    setMeta('name', 'robots', 'index, follow');

    const url = `${BASE_URL}${config.path}`;
    let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:title', config.title);
    setMeta('property', 'og:description', config.description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', config.title);
    setMeta('name', 'twitter:description', config.description);

    const schemaId = 'page-jsonld';
    const existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    if (config.schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = schemaId;
      script.textContent = JSON.stringify(config.schema);
      document.head.appendChild(script);
    }

    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);
}

export const SITE_META = {
  name: SITE_NAME,
  url: BASE_URL,
  email: 'contact@baoliao-nav.example.com',
};